// achievements
import achievementBg from './achievements/achievement-bg.png';

// branding
import logo from './icons/logo-dtba@2x.png';
import signet from './icons/signet@2x.png';
import activerse from './icons/activerse_logo_horizontal.svg';

// navbar
import chevron from './navbar/chevron.svg';
import close from './navbar/close.svg';
import hamburger from './navbar/hamburger.svg';
import login from './navbar/login.svg';

// store logs
import appStore from './icons/app_store_badge.svg';
import googlePlay from './icons/google_play_badge.svg';

// common icons
import backIcon from './icons/back.svg';
import infoIcon from './icons/info.svg';
import settingsIcon from './icons/settings.svg';

import eye from './icons-master/eye-solid.svg';
import eyeSlash from './icons-master/eye-slash-solid.svg';

import DownArrow from './icons/chevron-down.svg?react';
import LeftArrow from './icons/chevron-left.svg?react';
import RightArrow from './icons/chevron-right.svg?react';

import imagePlaceholder from './image-placeholder.jpeg';

// hydration
import hydrationSuccessIcon from './hydration/hydration.goalReachedIcon.svg';
import hydrationSuccessIconLarge from './hydration/hydration.goalReachedImg.svg';

// errors
import unauthorized from './other-pages/AccessUnauthorizedExceptionImg@2x.png';
import error404Img from './errors/404Img.svg';
import genericErrorImg from './errors/UniversalErrorImg.svg';
import networkErrorImg from './errors/NetworkErrorImg.svg';
import noAccountErrorImg from './errors/NoAccountImg.svg';

// remove account
import removeAccountSuccess from './remove-account/notificationIcon.success.svg';
import removeAccountAlert from './remove-account/notificationIcon.danger.svg';
import removeAccountError from './remove-account/notificationIcon.error.svg';
import doneIcon from './remove-account/doneIcon.svg';

// thank you page
import thankYouPageBg from './thankyou/thank-you-page-main-img@2x.png';
import thankYouPageBgMobile from './thankyou/thank-you-page-main-img-mob@2x.png';
import thankYouPageAppEn from './thankyou/app-features-img@2x.png';
import thankYouPageLogInEn from './thankyou/log-in-img@2x.png';
import thankYouPageAppPl from './thankyou/app-features-img-pl@2x.png';
import thankYouPageLogInPl from './thankyou/log-in-img-pl@2x.png';
import confirm from './thankyou/activation-page-img-mob.png';
import emailIcon from './thankyou/thankUPage.step1.icon.svg';
import deliveryIcon from './thankyou/thankUPage.step2.icon.svg';
import phoneIcon from './thankyou/thankUPage.step3.icon.svg';

// meals - shopping-list
import shoppingListIcon from './meals/groceries.navbar.svg';
import noDietImg from './shopping-list/noShoppingListImg@2x.png';
import handdrawnIcon from './shopping-list/shoppingTipsBoxIcon.svg';
import instacartLogo from './icons/instacart.svg';
import friscoLogo from './icons/frisco.svg';

// meals - cookbook
import cookbookFavMealsIcon from './title-bar/cookbook-fav-meals.svg';
import cookbookFavouriteFull from './meals/cookbook.mealThumbFavoriteIcon.largeRibbon.active@2x.png';
import cookbookFavouriteEmpty from './meals/cookbook.mealThumbFavoriteIcon.largeRibbon@2x.png';
import favouriteFullSmall from './meals/cookbook.mealThumbFavoriteIcon.smallRibbon.active.primaryColor@2x.png';
import favouriteEmptySmall from './meals/cookbook.mealThumbFavoriteIcon.smallRibbon.primaryColor@2x.png';
import favouritesIcon from './meals/cookbook.noFavMels.svg';
import star from './meals/meal.mealTipBoxIcon.svg';

import iconChange from './meals/meal.changeIngredientIcon.svg';
import iconChangeDone from './meals/meal.changeIngredientIcon.active.svg';
import iconChangeActive from './meals/meal.changedIngredientIcon.svg';

// meals - common
import searchIcon from './meals/searchInputIcon.svg';
import minus from './meals/meal.minusItem.svg';
import minusMulti from './meals/meal.minusSet.svg';
import plus from './meals/meal.plusItem.svg';
import plusMulti from './meals/meal.plusSet.svg';

import ratingStarEmpty from './meals/meal.rateFullSmallIcon.mainColor-1.svg';
import ratingStarHalf from './meals/meal.rateHalfLargeIcon.mainColor.svg';
import ratingStarFull from './meals/meal.rateFullSmallIcon.mainColor.svg';

import ratingStarPopupEmpty from './meals/meal.rateEmptyLargeIcon.primaryColor.svg';
import ratingStarPopupFull from './meals/meal.rateFullLargeIcon.primaryColor.svg';

import ratingButtonEmpty from './meals/meal.rateFilledButtonIcon.svg';
import ratingButtonFull from './meals/meal.rateEmptyButtonIcon.svg';

import noSearchResultsIcon from './meals/noSearchResultsIcon.svg';

// meals - dayplan
import favMealsIcon from './meals/mealPlan.favorite.navbar.svg';
import favouriteFull from './meals/mealPlan.mealThumbFavoriteIcon.largeHeart.active@2x.png';
import favouriteEmpty from './meals/mealPlan.mealThumbFavoriteIcon.largeHeart@2x.png';

import gearIcon from './meals/gear.svg';
import buttonChange from './meals/meal.changeButtonIcon.svg';
import eatenButton from './meals/meal.eatenEmptyButtonIcon.svg';
import eatenButtonFull from './meals/meal.eatenFilledButtonIcon.svg';
import doneKcal from './meals/meal.kcalDoneIcon.svg';
import playBtn from './meals/mealsPlayButton.svg';

import tomorrowAlertIcon from './meals/mealPlanNotificationIcon.svg';
import bulb from './meals/dieticianNoteIcon.svg';
import copyForTomorrow from './meals/meal.doneButtonIcon.svg';

import fastingStatusFasting from './if/fasting-status-fasting.svg';
import fastingStatusEating from './if/fasting-status-eating.svg';

import changeButton from './meals/meal.changeIngredientIcon.svg';
import iconChangeDone2 from './meals/meal.changeIngredientIcon.active.svg';
import iconChangeActive2 from './meals/meal.changedIngredientIcon.svg';

import changeMealIcon from './meals/meal.changeMealButton.svg';
import favIcon from './meals/smallFavoriteIcon.svg';

import mealPlanPrice from './dayplan-master/diet_price.svg';

import weightNeeded from './meals/measurementImg.svg';
import goalLost from './meals/goalLostImg@2x.png';
import goalReached from './meals/goalAchievedImg@2x.png';
import noDietEn from './meals/noDietImgEn.png';
import noDietPl from './meals/noDietImgPl.png';
import dietInFuture from './meals/dietAvailableSoonImg.svg';
import pendingPayment from './meals/paymentPendingImg.svg';

// meals - fav meals
import addToMealplan from './meals/meal.addButtonIcon.svg';
import favouritesIcon2 from './meals/mealPlan.favorites.noMeals.icon@2x.png';

// flags
import flagEn from './icons/flags/en-US.svg';
import flagSv from './icons/flags/sv-SE.svg';
import flagPl from './icons/flags/pl-PL.svg';

const images = {
  achievementBg,
  logo,
  signet,
  activerse,
  backIcon,
  eye,
  eyeSlash,
  unauthorized,
  favouriteFull,
  favouriteEmpty,
  searchIcon,
  favMealsIcon,
  playBtn,
  instacartLogo,
  friscoLogo,
  star,
  hydrationSuccessIcon,
  hydrationSuccessIconLarge,
  error404Img,
  genericErrorImg,
  networkErrorImg,
  noAccountErrorImg,
  removeAccountSuccess,
  removeAccountAlert,
  removeAccountError,
  settingsIcon,
  appStore,
  googlePlay,
  imagePlaceholder,
  thankYouPageBg,
  thankYouPageBgMobile,
  thankYouPageAppEn,
  thankYouPageLogInEn,
  thankYouPageAppPl,
  thankYouPageLogInPl,
  confirm,
  infoIcon,
  shoppingListIcon,
  doneKcal,
  fastingStatusFasting,
  fastingStatusEating,
  changeButton,
  eatenButton,
  eatenButtonFull,
  tomorrowAlertIcon,
  noDietImg,
  handdrawnIcon,
  bulb,
  iconChangeDone2,
  iconChangeActive2,
  weightNeeded,
  goalLost,
  goalReached,
  noDietEn,
  noDietPl,
  dietInFuture,
  pendingPayment,
  changeMealIcon,
  favIcon,
  noSearchResultsIcon,
  addToMealplan,
  favouritesIcon2,
  mealPlanPrice,
  ratingStarEmpty,
  ratingStarHalf,
  ratingStarFull,
  ratingButtonEmpty,
  ratingButtonFull,
  ratingStarPopupEmpty,
  ratingStarPopupFull,
  buttonChange,
  copyForTomorrow,
  gearIcon,
  cookbookFavMealsIcon,
  cookbookFavouriteFull,
  cookbookFavouriteEmpty,
  favouriteFullSmall,
  favouriteEmptySmall,
  favouritesIcon,
  minus,
  minusMulti,
  plus,
  plusMulti,
  iconChange,
  iconChangeDone,
  iconChangeActive,
  doneIcon,
  emailIcon,
  deliveryIcon,
  phoneIcon,
  flagEn,
  flagSv,
  flagPl,
  chevron,
  close,
  hamburger,
  login,
};

export const svgInline = {
  DownArrow,
  LeftArrow,
  RightArrow,
};

export default images;
